import { render } from "./NavSection.vue?vue&type=template&id=427aaf1c&scoped=true"
import script from "./NavSection.vue?vue&type=script&lang=js"
export * from "./NavSection.vue?vue&type=script&lang=js"

import "./NavSection.vue?vue&type=style&index=0&id=427aaf1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427aaf1c"]])

export default __exports__